import { render } from "./PDCSetup.vue?vue&type=template&id=4f53ca5f"
import script from "./PDCSetup.vue?vue&type=script&lang=js"
export * from "./PDCSetup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__